const WORD = 'SWELLSCOUT';

export default function LoadingOverlay({ message }: { message: string }) {
  return (
    <div id="loading">
      <div className="wavey">
        {WORD.split('').map((c, i) => (
          <span key={i} style={{ animationDelay: `${i * 0.07}s` }}>
            {c}
          </span>
        ))}
      </div>
      <div className="lmsg">{message}</div>
    </div>
  );
}
